import { isGuardianDomain } from './lib/domain.js';
import { consentOrPayCountries } from './lib/sourcepointConfig.js';
let _isConsentOrPay = false;
const setIsConsentOrPay = (isConsentOrPay) => {
    _isConsentOrPay = isConsentOrPay;
};
const getIsConsentOrPay = () => {
    return _isConsentOrPay;
};
const isConsentOrPayCountry = (countryCode) => {
    return consentOrPayCountries.includes(countryCode);
};
const getSupportSignUpPage = () => {
    return isGuardianDomain() ? `https://support.theguardian.com/guardian-ad-lite?returnAddress=${encodeURIComponent(window.location.href)}` : `https://support.code.dev-theguardian.com/guardian-ad-lite?returnAddress=${encodeURIComponent(window.location.href)}`;
};
export { getIsConsentOrPay, getSupportSignUpPage, isConsentOrPayCountry, setIsConsentOrPay };
